export default __webpack_public_path__ + "static/media/house-manager.246c92b7.svg";